import { ExternalContent } from './externalContent/ExternalContent'
import { MacysLearnMore } from './macys/Macys'
import { Checkout } from './checkout/Checkout'

export default {
  macys: MacysLearnMore,
  macys_express_button: MacysLearnMore,
  external_content: ExternalContent,
  checkout: Checkout
}
